import { useCallback, useState } from "react"
import { CalendarBlank, CaretDown } from "@phosphor-icons/react"
import { format } from "date-fns"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import { VISUAL_DATE_FORMAT } from "@/components/ui/date-picker"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { useShiftPlanFiltersStore } from "@/modules/shift-plan-overview/stores/useShiftPlanFiltersStore"

export const ShiftPlanDatePicker = () => {
  const [open, setOpen] = useState(false)
  const selectedDate = useShiftPlanFiltersStore((state) => state.selectedDate)
  const setSelectedDate = useShiftPlanFiltersStore((state) => state.actions.setSelectedDate)

  const displayDate = format(selectedDate, VISUAL_DATE_FORMAT)

  const handleDateSelect = useCallback(
    (date: Date | undefined) => {
      if (date) {
        setSelectedDate(date)
        setOpen(false)
      }
    },
    [setSelectedDate],
  )

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="secondary"
          data-testid="shift-plan-date-filter-trigger"
          className="bg-background h-8 w-fit items-center gap-1.5 rounded-md px-3 text-sm leading-5 font-medium">
          <CalendarBlank size={16} />
          <div>{displayDate}</div>
          <CaretDown size={20} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="bg-surface w-auto rounded-lg p-0" align="start">
        <Calendar mode="single" selected={selectedDate} onSelect={handleDateSelect} />
      </PopoverContent>
    </Popover>
  )
}
